// import { PointSpreadLoading } from "react-loadingg";
import { FiSettings } from "react-icons/fi";
export default function Loadingg() {
  return (
    <div className="App">
      <h1 style={{ marginTop: "360px", marginRight: "160px" }}>
        <FiSettings />
      </h1>
      <h1>
        {/* <PointSpreadLoading /> */}
      </h1>
    </div>
  );
}
